import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EQuestionnaireStatus, QuestionnaireRow } from 'src/app/models/questionnaireGrid.model';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionnairesGridStore } from 'src/app/features/questionnaires/store/questionnairesGrid-store';
import { EReplyStatus, Recipient, Recipients } from 'src/app/models/recipients.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { GlobalStore } from 'src/app/store/global-store';
import { MatDialog } from '@angular/material/dialog';
import { ChooseRecipientsComponent } from 'src/app/features/users/components/choose-recipients/choose-recipients.component';
import { SaveNameListComponent } from 'src/app/features/create-questionnaire-page/component/question-form/components/save-name-list/save-name-list.component';
import { MessagePopupComponent } from 'src/app/features/create-questionnaire-page/component/question-form/components/autocomplete-question/component/answer-option-item-input/message-popup/message-popup.component';
import { environment } from 'src/environment';
import { AnswersApiService } from 'src/app/services/answers-api.service';
import { AnswersStore } from 'src/app/store/answers-store';
import { TostesStore } from 'src/app/store/tostes-store';
import { TostTypeEnum } from 'src/app/shared/models/tostes.model';
import { Clipboard as CdkClipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';



@Component({
    selector: 'que-questionnaires-menu-item',
    imports: [CommonModule, MatMenuModule, TranslateDirective, TranslatePipe, OverlayModule, ClipboardModule],
    templateUrl: './questionnaires-menu-item.component.html',
    styleUrls: ['./questionnaires-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionnairesMenuItemComponent implements OnInit {
  @Input()
  questionnaire?: QuestionnaireRow;
  @ViewChild('trigger') trigger!: ElementRef;
  @ViewChild('answerByTrigger') answerByTrigger!: ElementRef;
  #questionnaireGridStore = inject(QuestionnairesGridStore);
  #globalStore = inject(GlobalStore);
  #answersApiService = inject(AnswersApiService);
  #clipboard: CdkClipboard = inject(CdkClipboard);
  #tostesStore = inject(TostesStore);
  // #answersStore = inject(AnswersStore);
  #router = inject(Router)
  #dialog = inject(MatDialog);
  #manipulationStore = inject(ManipulationsToolbarStore);
  isRoleAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);
  isDisplayUser$ = toSignal(this.#manipulationStore.isDisplayUser$);
  users?: Recipient[] = [];
  usersNotAnswered?: Recipient[] = [];
  enumQStatus = EQuestionnaireStatus;
  enumReplyStatus = EReplyStatus;
  isMenuOpen$ = signal(false);
  copied = signal<boolean>(false);
  isDev = true;
  isAnswerByOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];
  readonly positonArea2 = [{
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  ngOnInit(): void {
    this.users = [
      ...(this.questionnaire?.recipients?.users ?? []),
      ...(this.questionnaire?.recipients?.groups?.map(x => x.users?.map(y => y)) ?? []),
    ].flat() as Recipient[];
    this.usersNotAnswered = [
      ...new Map(
        this.users
          .filter(u =>
            (this.questionnaire?.definitions.isUnauthorized || (!this.questionnaire?.definitions.isUnauthorized && !!u.guidToUser?.trim())) && u.user.id != null)
          .map(u => [String(u.user.id), u])
      ).values()
    ];
  }
  openMenu(event: Event) {
    event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 400 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuOpen$.set(true);
  }
  view() {
    this.#router.navigate([`create/${this.questionnaire?.id}/preview`], { queryParams: { isNotEdit: this.questionnaire?.status != EQuestionnaireStatus.Edit } })
  }
  viewRequest() {
    if (this.questionnaire?.guidToUser) {
      this.#router.navigate(['viewAnswers', this.questionnaire.guidToUser, 0]);
    }
  }
  edit() {
    this.#router.navigate([`create`, `${this.questionnaire?.id}`])
  }
  duplicate() {
    this.#dialog.open(SaveNameListComponent,
      {
        autoFocus: false,
        data: {
          isDuplicateQuestionnairePopup: true,
          name: this.questionnaire?.name
        }
        //  position: { top: '1.6%', right: '17%' }
        // position: { top: '1.6%',left : lang=='he'?'' : '17%',right : lang=='en'?'' : '17%'}
      }
    ).afterClosed()
      .subscribe((resultFromPopUp: string) => {
        if (resultFromPopUp) {
          this.#questionnaireGridStore.duplicateQuestionnaire({ id: this.questionnaire?.id ?? 0, name: resultFromPopUp })
        }
      }
      )
  }
  delete() {
    this.#dialog.open(MessagePopupComponent, {
      data:
        environment.lang == 'he' ?
          { message: `האם אתה בטוח שברצונך למחוק את השאלון ${this.questionnaire?.name == "" ? "שאלון ללא שם" : this.questionnaire?.name ?? "שאלון ללא שם"} ?` } :
          { message: `Are you sure you want to delete the questionnaire ${this.questionnaire?.name == "" ? "Anonymouse Questionnaire" : this.questionnaire?.name ?? "Anonymouse Questionnaire"}?` }
    }).afterClosed().subscribe(
      x => {
        if (x) {
          this.#questionnaireGridStore.deleteQuestionnaire(this.questionnaire?.id ?? 0);
        }
        else {
          this.isMenuOpen$.set(false);
        }
      }
    );
  }
  navToData() {
    this.#router.navigate(['data', `${this.questionnaire?.id}`]);
  }
  answerIt() {
    if (this.questionnaire?.guidToUser)
      this.#router.navigate(['answer', `${this.questionnaire?.guidToUser}`])
  }
  addRecipients() {
    this.isMenuOpen$.set(false);
    this.#dialog.open(ChooseRecipientsComponent,
      {
        data: {
          mailForm: { subject: this.questionnaire?.distributionDetails?.mailSubject, body: this.questionnaire?.distributionDetails?.mailBody, submissionDateNTZ: this.questionnaire?.submissionDateNTZ },
          ...this.questionnaire,
          isReminder: false,
          isAddRecipients: true,
          editReminder: this.questionnaire?.distributionDetails?.reminder,
          isSendAll: this.questionnaire?.distributionDetails?.isSendAll
        },
        autoFocus: false,
        panelClass: 'dialog-panel'
      }).afterClosed()
      .subscribe((result) => {
        if (result) {
          const [users, reminder, mailForm, event, isSendAll] = result;
          if ((users || mailForm) && event) {
            this.#questionnaireGridStore.saveDistributionDetails({ questionnaireId: this.questionnaire?.id, users: users as Recipients, mailForm, reminder, isPublish: true, isSendAll })
          }
        }
      })
  }

  openAnswerBy() {
    const triggerRect = this.answerByTrigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    // Check if the menu would open out of the viewport
    // if (triggerRect.bottom + 400 > viewportHeight) { // assuming 200px height for the menu
    //   this.positonArea2[0].overlayY = 'bottom';
    // } else {
    //   this.positonArea2[0].overlayY = 'top';
    // }
    // if (triggerRect.right +60> viewportWidth) {
    //   this.positonArea2[0].originX = 'center';
    // } 
    this.isAnswerByOpen = true;
  }
  answerItBy(guid?: string) {
    if (!guid) {
      this.#router.navigateByUrl(
        `/answer/questionnaire/${this.questionnaire?.id}?unauthorized=true`
      );
    }
    else
      this.#router.navigate(['answer', `${guid}`])
  }

  downloadPdfToUser() {
    if (this.questionnaire?.statusToUser != EReplyStatus.NotStarted && this.questionnaire?.guidToUser) {
      this.#answersApiService.downloadPdfToUser(this.questionnaire?.id ?? 0, this.questionnaire?.name ?? "", this.questionnaire?.guidToUser)
    }
  }

  cancelRequest() {
    if (this.questionnaire?.guidToUser) {
      this.#questionnaireGridStore.cancelRequest({ guid: this.questionnaire.guidToUser });
    }
  }

  duplicateRequest() {
    if (this.questionnaire?.guidToUser) {
      this.#questionnaireGridStore.duplicateRequest({ guid: this.questionnaire.guidToUser });
    }
  }

  addUnauthorizedUrl() {
    // this.#answersStore.addUnauthorizedUrl(this.questionnaire?.id ?? 0);
    const freeUrl = `${window.location.origin}/answer/questionnaire/${this.questionnaire?.id}?unauthorized=true`;
    this.#dialog.open(MessagePopupComponent, {
      data:
        environment.lang == 'he' ?
          {
            message: `קישור להפצה חופשית של שאלון ${this.questionnaire?.name == "" ? "שאלון ללא שם" : this.questionnaire?.name ?? "שאלון ללא שם"} `,
            message2: freeUrl, btnActive: "העתק קישור"
          } :
          {
            message: `Free distribution link for questionnaire ${this.questionnaire?.name == "" ? "Anonymous Questionnaire" : this.questionnaire?.name ?? "Anonymous Questionnaire"} `
            , message2: freeUrl, btnActive: "Copy Link"
          }
    }).afterClosed().subscribe(
      x => {
        if (x) {
          this.copied.set(this.#clipboard.copy(freeUrl));
          this.#tostesStore.addTost({
            guid: "",
            message: environment.lang == 'he' ? { en: "Link copied to clipboard", he: "הקישור הועתק ללוח" } : { en: "Link copied to clipboard", he: "הקישור הועתק ללוח" },
            type: TostTypeEnum.SUCCESS,
            seconds: 3
          });


        }
        else {
          this.isMenuOpen$.set(false);
        }
      }
    );
    // this.#answersApiService.addUnauthorizedUrl(this.questionnaire?.id ?? 0).subscribe(unauthorizedUrl => {
    //   console.log({
    //     message: { en: `Unauthorized URL: ${unauthorizedUrl}`, he: `קישור ללא הרשאה: ${unauthorizedUrl}` },
    //     type: TostTypeEnum.SUCCESS,
    //     seconds: 10
    //   });
    // });

  }
  get viewStatusFlow(): boolean {
    const isApprovalRequired = this.questionnaire?.definitions?.isApprovalRequired ?? false;
    const status = this.questionnaire?.statusToUser;

    return isApprovalRequired &&
      (
        status === EReplyStatus.PendingApproval ||
        status === EReplyStatus.Approved ||
        status === EReplyStatus.Rejected
      );
  }
  isApprovalFlowOpen = false;

  toggleApprovalFlow(): void {
    this.isApprovalFlowOpen = !this.isApprovalFlowOpen;
    this.#questionnaireGridStore.updateCurrentQuestionnaire({
      questionnaire: null
    });
    this.#questionnaireGridStore.updateCurrentQuestionnaire({
      questionnaire: this.questionnaire!
    });
    this.#globalStore.updateIsOpenStatusFlow(true);
    this.isMenuOpen$.set(false);

  }
}
